import { useRestaurant } from '../context/RestaurantContext';

/**
 * Custom hook to get the current restaurant ID for API calls
 * This hook provides the current restaurant ID from the context
 */
const useCurrentRestaurant = () => {
  const { restaurantId, loading } = useRestaurant();

  return {
    restaurantId,
    loading
  };
};

export default useCurrentRestaurant;
